import React, {useMemo} from 'react';
import Language from "../components/Language";
import {getAppName, getLogoFileName, getWhiteLabelName} from "../utils/whitelabel";
import {cn} from "../utils/style";
import Logo from "../components/Logo";
import {useTranslation} from "react-i18next";
import {isIframe} from "../utils/iframe";
import {BeakerIcon} from "@heroicons/react/24/outline";

function InvoiceLayout({children, test, invoice, showLang}) {
    const {t} = useTranslation();
    const embedded = isIframe();

    return (
        <div
            className={cn(
                "container relative max-w-4xl px-4 mx-auto flex min-h-full flex-1 flex-col justify-center py-4 md:py-12 sm:px-6 lg:px-8",
                embedded && "py-0 md:py-0 px-0 sm:px-0 lg:px-0 max-w-full"
            )}>
            <div className="flex items-center justify-between">
                {invoice && !embedded && <Logo/>}
                <div className="flex items-center gap-2">
                    {/*{showLang && <Language className="hidden sm:block"/>}*/}
                    {test && (
                        <div className="flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-50 border border-amber-100/50 shadow-sm animate-pulse">
                            <div className="flex-shrink-0">
                                <BeakerIcon className="h-4 w-4 text-amber-500" />
                            </div>
                            <span className="text-[10px] font-black uppercase tracking-[0.15em] text-amber-600">
                                {t('payment.filter.test_mode')}
                            </span>
                        </div>
                    )}
                </div>
            </div>
            {children}
        </div>
    );
}

export default InvoiceLayout;